import { useEffect } from 'react';
import AppleAuth from './components/AppleAuth';
import arisLogo from '../../Assets/icon/aris_logo.svg';
import './AuthPages.css';

const AppleCallbackPage = () => {
  return (
    <div className="auth-page-container">
      <div className="auth-page-content">
        <img src={arisLogo} alt="Aris" className="auth-page-logo" />
        <h2 className="auth-page-title">Completing Apple Sign-In...</h2>
        <p className="auth-page-subtitle">Please wait while we complete your sign-in.</p>
        
        {/* AppleAuth component will handle the callback automatically via useEffect */}
        <AppleAuth />
      </div>
    </div>
  );
};

export default AppleCallbackPage;
